module.exports = __webpack_public_path__ + "assets/img/investors.56433206.jpg";